import { Component, OnInit, TemplateRef } from '@angular/core';
import { CommonService } from '../../shared/services/common.service';
import { ApplicantType, OwnershipType, RegionType, TinClaim, WoredaType, ZoneType, City, SubCityType} from '../../models/CommonModels';
import { ChangeFakeTinModel, Facility, Organization, UserOrganization } from '../../models/ApplicationModel';
import { UserDto, vwUser } from '../../models/User';
import { UserService } from '../../services/user.service';
import { AlertService } from '../../shared/services/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FacilityService } from '../../shared/services/facility.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { AccountService } from '../../services/account.service';
import { ErrorHandlerService } from '../../services/error-handler.service';
import * as Constants from "../../models/Constants";

@Component({
  selector: 'app-manage-tin',
  templateUrl: './manage-tin.component.html',
  styleUrls: ['./manage-tin.component.css']
})
export class ManageTinComponent implements OnInit {

  public tab: string;
  public applicantTypes :  ApplicantType[] = [];
  public organizationTypes : OwnershipType[] = [];
  public tinClaim : TinClaim = new TinClaim();
  public ownedOrganizations : Organization[] = null;
  public associateApplicant : UserOrganization = new UserOrganization();
  public filteredApplicants : vwUser[] = [];
  public applicantSearchTerm = '';
  public associatedApplicants : UserOrganization[] = [];
  public associationTobeRemoved : UserOrganization;
  public modalRef: BsModalRef;
  //TODO: move all user creation/update code to one component to remove duplication
  public newApplicant : UserDto;
  public constants: any = Constants;
  public userErrorMessage:string= '';
  public regionTypes : RegionType[];
  public zoneTypes : ZoneType[];
  public woredaTypes : WoredaType[];
  public subCityTypes: SubCityType[];
  public cities : City[];
  public showTinClaimForm = false;
  public isOrganizationPrivate = false;
  public searchingMethods = [{'name' : 'Search by Tin', 'code' : 'TIN'}, { 'name' : 'Search by User', 'code':'USER'}];
  public selectedSearchMethod = 'TIN';
  public searchQueryTerm = '';
  showSubCity: boolean;
  public associatedFacilities : Facility[] = [];
  public selectedFacilityId: number;
  public newFacilityTin: string = '';

  constructor(private commonService: CommonService, private userService: UserService,private alertService: AlertService,
    private spinner: NgxSpinnerService, private facilityService: FacilityService, private modalService: BsModalService,
    private accountService: AccountService, private errorHandlerService: ErrorHandlerService) { }

  ngOnInit() {
    this.tab = 'organization';
    if(this.isUserApplicant()){
      this.commonService.getApplicationTypes().subscribe(resp => {
        this.applicantTypes = resp.filter(a => a.applicationTypeCode == Constants.FOCAL_PERSON || a.applicationTypeCode == Constants.TECHNICAL_MANAGER);
      });
      this.commonService.getOwnershipTypes().subscribe(resp => this.organizationTypes = resp);
      this.getOrganizationApplicantAssociations();
      this.getLocationLookups();
    }

    if(this.isUserSuperAdmin()){
      this.tab = 'adminManagement';
    }
  }

  tabClicked(tab){
    this.tab = tab;
  }

  activeTab(tab) {
    return this.tab === tab;
  }

  getOrganizationApplicantAssociations(){
    this.facilityService.getOrganizationApplicantAssociations().subscribe(resp => {
      let user = this.accountService.getUserData();
      this.ownedOrganizations = resp.filter(r => r.applicantType.name === "Owner" && r.userID === user.id).map(r => r.organization);
      // allow to claim tin if all of the owned tins are fake tins
      this.showTinClaimForm = this.ownedOrganizations.length == 0 || this.ownedOrganizations.every(c => c.tinNumber.length == 10 &&
           c.tinNumber.substr(5) == '00000');
      this.associatedApplicants = resp.filter(r => r.applicantType.name !== "Owner" && r.userID !== user.id);
      if(this.accountService.isUserApplicant()){
        this.accountService.storeUserTinData(resp);
      }
      if(resp.length == 0){
        this.alertService.info("Welcome, you don't have any Tin associated with your account. please claim a Tin to apply for a License");
      }
    });
  }

  getFilteredApplicants(event){
    if(event.term && event.term.length > 3 && this.applicantSearchTerm != event.term){
      this.applicantSearchTerm = event.term;
      this.userService.getFilteredApplicants(event.term).subscribe(resp => {
        this.filteredApplicants = resp;
      });
      console.log(event);
    }
  }

  claimTin(){
    this.spinner.show();
    console.log(this.tinClaim);
    this.facilityService.claimTin(this.tinClaim).subscribe(resp => {
      this.getOrganizationApplicantAssociations();
      this.spinner.hide();
      this.tinClaim = new TinClaim();
      this.alertService.success("You have successfully claimed the Tin, You can now apply for License");
    }, err => {
      this.spinner.hide();
      this.alertService.error(this.errorHandlerService.handleApiError(err));
    });
  }

  openAlertModal(template: TemplateRef<any>, associationTobeRemoved) {
    this.associationTobeRemoved = associationTobeRemoved;
    this.modalRef = this.modalService.show(template);
  }

  closeModal() {
    this.associationTobeRemoved = null;
    this.modalRef.hide();
  }

  removeEmployee() {
    this.facilityService.deleteUserOrganization(this.associationTobeRemoved.id).subscribe(
      res => {
          if (res) {
            this.associatedApplicants = this.associatedApplicants.filter(a => a.id != this.associationTobeRemoved.id);
            this.alertService.success('Successfully removed the employee.');
          }else {
            this.alertService.error('Unable to remove the employee.');
          }
      },
      err => {
        this.alertService.error(this.errorHandlerService.handleApiError(err));      
      },
      () => {
        this.closeModal();
      }
    );
  }

  assciateApplicant(){
    this.spinner.show();
    console.log(this.associateApplicant);
    this.facilityService.createUserOrganization(this.associateApplicant).subscribe(resp => {
      this.getOrganizationApplicantAssociations();
      this.spinner.hide();
      this.associateApplicant = new UserOrganization();
      this.alertService.success("You have successfully associated the Employee to the Organization");
    }, err => {
      this.spinner.hide();
      this.alertService.error(this.errorHandlerService.handleApiError(err));    
    });
  }

  showAddApplicantModal(template: TemplateRef<any>){
    this.newApplicant = new UserDto();
    this.modalRef = this.modalService.show(template, {backdrop: 'static', keyboard: false});
  }

  removeAlert(){
    this.userErrorMessage = '';
  }

  getLocationLookups(){
    this.commonService.getRegionTypes().subscribe(regionTypes => {
      this.regionTypes = regionTypes;
    });

    this.commonService.getCities().subscribe(cities => {
      this.cities = cities;
    });
  }

  updateHierarchyLists(adminBoundary:any, source:string){
    if (adminBoundary !== undefined) {
      switch (source) {

        case 'region':
          adminBoundary = <RegionType>adminBoundary;
          this.newApplicant.address.zoneId = null;
          this.newApplicant.address.woredaId = null;
          this.sortHierarchy(adminBoundary, source);
          this.woredaTypes = [];
          break;

        case 'zone':          
          adminBoundary = <ZoneType>adminBoundary;
          this.showSubCity = adminBoundary.isCity ? true: false;
          this.newApplicant.address.woredaId = null;
          this.newApplicant.address.subCityId = null;
          this.sortHierarchy(adminBoundary, source);
          break;
        case 'subCity':
          adminBoundary = <ZoneType>adminBoundary;
          this.newApplicant.address.woredaId = null;
          this.sortHierarchy(adminBoundary, source);
          break;
      }
    }
  }

  sortHierarchy = function (adminBoundary, source: string) {
    let selectedBoundaryID = adminBoundary !== null ? adminBoundary.id : -1;
    switch (source) {
      case 'region':
        this.commonService.getZoneTypesByRegion(selectedBoundaryID).subscribe(zoneTypes => {
          this.zoneTypes = zoneTypes;
        });
        break;
      case 'zone':
        if(adminBoundary.isCity){
          this.commonService.getSubCityTypesByZone(selectedBoundaryID).subscribe(subCityTypes => {
            this.subCityTypes = subCityTypes;
          });
        } else {
          this.commonService.getWoredaTypesByZone(selectedBoundaryID).subscribe(woredaTypes => {
            this.woredaTypes = woredaTypes;
          });
        }
        break;
      case 'subCity':
        this.commonService.getWoredaTypesBySubCity(selectedBoundaryID).subscribe(woredaTypes => {
          this.woredaTypes = woredaTypes;
        });
        break;
      default:
        break;
    }
  };

  createNewApplicant(){
    debugger;
    this.spinner.show();
    this.userService.createUser(this.newApplicant).subscribe(
      resp => {    
        if(resp){       
          this.userService.getFilteredApplicants(this.newApplicant.username).subscribe(vwusers => {
            this.alertService.success("Employee Account Created Successfully, The password for the new user is " + resp.newPassword);
            this.filteredApplicants = vwusers;
            this.associateApplicant.userID = this.filteredApplicants.find(ap => ap.username == this.newApplicant.username).id;
            this.spinner.hide();
            this.modalRef.hide();
          });        
        }else{
          this.alertService.success("Unable to Create Account, Please try again");
          this.spinner.hide();
        }
      },
      error => {
        let errorMsg = this.errorHandlerService.handleApiError(error);
        this.userErrorMessage= errorMsg + " , Please try again"
        setTimeout(() => {
          this.removeAlert();
         }, 15000);
        this.spinner.hide();
      });
  }

  organizationTypeChanged(){
    let orgType = this.organizationTypes.find(o => o.id == this.tinClaim.organizationTypeID);
    this.isOrganizationPrivate = orgType.name == "Private";
  }

  isUserApplicant(){
    return this.accountService.isUserApplicant();
  }

  isUserSuperAdmin(){
    return this.accountService.isUserSuperAdmin();
  }

  searchTinAssociation(){
    this.spinner.show();
    if(this.selectedSearchMethod == 'TIN'){
      this.facilityService.searchTinAssociationByTin(this.searchQueryTerm).subscribe(resp => {
        this.associatedApplicants = resp;
        this.spinner.hide();
      }, error => {
        console.log(error);
        this.spinner.hide();
      });

      this.facilityService.getFacilitiesByTin(this.searchQueryTerm).subscribe(resp => {
        this.associatedFacilities = resp;
        this.spinner.hide();
      }, error => {
        console.log(error);
        this.spinner.hide();
      });

    } else if(this.selectedSearchMethod == 'USER'){
      this.facilityService.searchTinAssociationByUser(this.searchQueryTerm).subscribe(resp => {
        this.spinner.hide();
        this.associatedApplicants = resp;
      }, error => {
        console.log(error);
        this.spinner.hide();
      });
    }
  }

  showChangeFacilityFakeTinModal(template: TemplateRef<any>, facilityId: number){
    this.selectedFacilityId = facilityId;
    this.modalRef = this.modalService.show(template, {backdrop: 'static', keyboard: false});
  }

  hideChangeFakeTinModal(){
    this.selectedFacilityId = 0;
    this.newFacilityTin = '';
    this.modalRef.hide();
  }

  changeFacilityFakeTin(){
    this.spinner.show();
    var data = new ChangeFakeTinModel(this.selectedFacilityId, this.newFacilityTin);
    this.facilityService.changeFakeTin(data).subscribe(resp => {
      this.spinner.hide();
      this.hideChangeFakeTinModal();
      if(resp){
        this.alertService.success("You have successfully update the facility Tin to " + this.newFacilityTin);
      } else {
        this.alertService.error("Change the Tin has failed, pleas try again!");
      }
      this.associatedFacilities = []
      this.associatedApplicants = []
    }, error => {
      this.spinner.hide();
      this.hideChangeFakeTinModal();
      this.alertService.error(this.errorHandlerService.handleApiError(error));
    })
  }
}
